import { GeofenceType } from '@cobliteam/common-types/src/geofenceV3';

import { LocationIcon, MaintenanceIcon, PersonIcon } from '../../icons';
import { Home, HomeWork, LocalGasStationRounded } from '@material-ui/icons';

import { colors } from '../../styles';

export default {
  [GeofenceType.BASE]: {
    label: 'Base',
    icon: <HomeWork />,
    activeColor: colors.primary.default,
  },
  [GeofenceType.HEADQUARTER]: {
    label: 'Sede',
    icon: <Home />,
    activeColor: colors.accessory._5,
  },
  [GeofenceType.SUPPLY]: {
    label: 'Abastecimento',
    icon: <LocalGasStationRounded />,
    activeColor: colors.accessory._2,
  },
  [GeofenceType.MAINTENANCE]: {
    label: 'Manutenção',
    icon: <MaintenanceIcon />,
    activeColor: colors.accessory._1,
  },
  [GeofenceType.CLIENT]: {
    label: 'Cliente',
    icon: <PersonIcon />,
    activeColor: colors.success.default,
  },
  [GeofenceType.OTHER]: {
    label: 'Outro',
    icon: <LocationIcon />,
    activeColor: colors.warning.default,
  },
};
